import { API_NAMES, initApi } from "../../../utils/HttpApiHelper";

const putMeetResultsStatisticsData = (meetId, numberOfSwimmers, numberOfSplashes, state, setState) => {
  const api = initApi(API_NAMES.MEET, state, setState);

  const meetIdForUrl = encodeURIComponent(meetId);
  const url = `/Meet/${meetIdForUrl}/MeetResultsStatistics/Swimmers/${numberOfSwimmers}/Splashes/${numberOfSplashes}`;
  
  return api?.executeObject ? api.executeObject(url, 'PUT') : null;
};

const MeetResultsStatisticsData = {
  putMeetResultsStatisticsData
}

export default MeetResultsStatisticsData;